





















import { defineComponent, computed, watch, ref, onMounted } from '@vue/composition-api';
import { isInEditor, pingEditor } from '@/storyblok';
import { messenger } from '../../messenger';

export default defineComponent({
  name: 'EmbeddedYoutubeVideo',
  props: { blok: { type: Object, required: true } },
  setup(props) {
    const inEditor = ref(false);
    const urlAdded = ref(false);
    const consented = ref(false);
    const consentKey = 'youtube-consent-accepted';

    onMounted(async () => {
      await pingEditor();
      inEditor.value = isInEditor();
      try {
        consented.value = localStorage.getItem(consentKey) === 'true';
      } catch (error) {
        consented.value = false;
      }
    });

    watch(
      [inEditor],
      () => {
        urlAdded.value = inEditor.value || process.env.VUE_APP_WEB;
        messenger.unity?.webview.excludeUrlFromOpeningExternally(props.blok.videoId).then(() => {urlAdded.value = true}).catch();
      },
      {
        immediate: true,
      }
    );
    return {
      src: computed(() => {
        const params: string[] = [];
        if (props.blok.startsAt) {
          params.push(`start=${props.blok.startsAt}`);
        }
        const query = params.length ? `?${params.join('&')}` : '';
        return `https://www.youtube.com/embed/${props.blok.videoId}${query}`;
      }),
      canLoad: computed(() => urlAdded.value && consented.value),
      acceptConsent: () => {
        consented.value = true;
        try {
          localStorage.setItem(consentKey, 'true');
        } catch (error) {
          // ignore storage errors; consent stays in memory
        }
      },
    };
  },
});
